var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeaple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7798 65.6899V97.9999",
    stroke: "#084298",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9502 41.3999L39.2402 97.9999",
    stroke: "#084298",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6001 41.3999L60.3101 97.9999",
    stroke: "#084298",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0101 2H50.0001C45.6481 2 42.1201 5.528 42.1201 9.88V13.85C42.1201 18.202 45.6481 21.73 50.0001 21.73H50.0101C54.3621 21.73 57.8901 18.202 57.8901 13.85V9.88C57.8901 5.528 54.3621 2 50.0101 2Z",
    stroke: "#084298",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.84 67.7601C30.46 65.3801 28.98 62.0901 28.98 58.4701V49.96V41.4501C28.98 37.8301 30.46 34.55 32.84 32.16C35.22 29.77 40.06 27.3 50 27.3C59.94 27.3 64.78 29.78 67.16 32.16C69.54 34.54 71.02 37.8301 71.02 41.4501V49.96V58.4701C71.02 62.0901 69.54 65.3701 67.16 67.7601",
    stroke: "#084298",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5599 47.29L88.3999 98",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2201 19.06C86.2201 15.1609 83.0592 12 79.1601 12C75.261 12 72.1001 15.1609 72.1001 19.06V22.61C72.1001 26.5091 75.261 29.67 79.1601 29.67C83.0592 29.67 86.2201 26.5091 86.2201 22.61V19.06Z",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.04 34.7699C77.02 34.7099 78.06 34.6699 79.17 34.6699C80.28 34.6699 81.33 34.6999 82.3 34.7699C83.27 34.8399 84.18 34.9299 85.03 35.0499C85.88 35.1699 86.66 35.3199 87.39 35.4799C88.12 35.6399 88.79 35.8399 89.4 36.0399C90.01 36.2399 90.58 36.4699 91.09 36.6999C91.6 36.9299 92.07 37.1799 92.49 37.4399C92.91 37.6999 93.29 37.9599 93.63 38.2199C93.97 38.4799 94.27 38.7499 94.54 39.0199C94.81 39.2899 95.06 39.5699 95.3 39.8599C95.54 40.1499 95.77 40.4499 95.98 40.7699C96.19 41.0899 96.39 41.4099 96.57 41.7399C96.75 42.0699 96.92 42.4199 97.07 42.7699C97.22 43.1199 97.35 43.4799 97.47 43.8499C97.59 44.2199 97.68 44.5899 97.76 44.9799C97.84 45.3699 97.9 45.7499 97.94 46.1499C97.98 46.5499 98 46.9499 98 47.3499V48.2999V49.2499V50.1999V51.1499V52.0999V53.0499V53.9999V54.9499V55.8999V56.8499V57.7999V58.7499V59.6999V60.6499V61.5999V62.5499C98 62.9499 97.98 63.3599 97.94 63.7499C97.9 64.1399 97.84 64.5299 97.76 64.9199C97.68 65.3099 97.58 65.6799 97.47 66.0499C97.36 66.4199 97.22 66.7799 97.07 67.1299C96.92 67.4799 96.75 67.8299 96.57 68.1599C96.39 68.4899 96.19 68.8199 95.98 69.1299C95.77 69.4399 95.54 69.7499 95.3 70.0399C95.06 70.3299 94.81 70.6099 94.54 70.8799",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4399 47.29L11.5999 98",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7799 22.6099C13.7799 26.5091 16.9408 29.6699 20.8399 29.6699C24.739 29.6699 27.8999 26.5091 27.8999 22.6099V19.0599C27.8999 15.1608 24.739 11.9999 20.8399 11.9999C16.9408 11.9999 13.7799 15.1608 13.7799 19.0599L13.7799 22.6099Z",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.96 34.7699C22.98 34.7099 21.94 34.6699 20.83 34.6699C19.72 34.6699 18.67 34.6999 17.7 34.7699C16.73 34.8399 15.82 34.9299 14.97 35.0499C14.12 35.1699 13.34 35.3199 12.61 35.4799C11.88 35.6399 11.21 35.8399 10.6 36.0399C9.99 36.2399 9.42 36.4699 8.91 36.6999C8.4 36.9299 7.93 37.1799 7.51 37.4399C7.09 37.6999 6.71 37.9599 6.37 38.2199C6.03 38.4799 5.73 38.7499 5.46 39.0199C5.19 39.2899 4.94 39.5699 4.7 39.8599C4.46 40.1499 4.23 40.4499 4.02 40.7699C3.81 41.0899 3.61 41.4099 3.43 41.7399C3.25 42.0699 3.08 42.4199 2.93 42.7699C2.78 43.1199 2.65 43.4799 2.53 43.8499C2.41 44.2199 2.32 44.5899 2.24 44.9799C2.16 45.3699 2.1 45.7499 2.06 46.1499C2.02 46.5499 2 46.9499 2 47.3499V48.2999V49.2499V50.1999V51.1499V52.0999V53.0499V53.9999V54.9499V55.8999V56.8499V57.7999V58.7499V59.6999V60.6499V61.5999V62.5499C2 62.9499 2.02 63.3599 2.06 63.7499C2.1 64.1399 2.16 64.5299 2.24 64.9199C2.32 65.3099 2.42 65.6799 2.53 66.0499C2.64 66.4199 2.78 66.7799 2.93 67.1299C3.08 67.4799 3.25 67.8299 3.43 68.1599C3.61 68.4899 3.81 68.8199 4.02 69.1299C4.23 69.4399 4.46 69.7499 4.7 70.0399C4.94 70.3299 5.19 70.6099 5.46 70.8799",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaple);
export default __webpack_public_path__ + "static/media/peaple.f51e3a0243da7393e9ab3294b6510c1e.svg";
export { ForwardRef as ReactComponent };